module.exports = {"TXTCLI_Required":{"id":"TXTCLI_Required","defaultMessage":"Obligatorisk","track":"Required"}}